import AppStorage from '@Services/AppStorage';

import {
  RECEIVED_RECENT_HISTORY,
  RECEIVED_SAVED_HISTORY,
  HANDLE_VIEW_SAVE_MODAL,
  HANDLE_NAME_CHANGE,
  ON_SUBMIT_SAVE,
  ON_SUBMIT_COMPLETE,
  HANDLE_VIEW_DELETE_MODAL,
  ON_DELETE,
  ON_DELETE_COMPLETE,
  ON_SAVE_UNLOAD,
} from './Constants';

const updateSavedHistoryOnRename = (state) => {
  const { groupItemIndex, itemIndex, savedHistory, saveModalNameInput } = state;
  const group = savedHistory[groupItemIndex];

  if (!group?.items?.[itemIndex]) {
    return savedHistory;
  }

  const updatedItems = [...group.items];
  updatedItems[itemIndex] = { ...updatedItems[itemIndex], searchName: saveModalNameInput };

  const updatedHistory = [...savedHistory];
  updatedHistory[groupItemIndex] = { ...group, items: updatedItems };

  return updatedHistory;
};

const updateSavedHistoryOnDelete = (state) => {
  const { groupItemIndex, itemIndex, savedHistory } = state;
  const group = savedHistory[groupItemIndex];

  if (!group?.items?.[itemIndex]) {
    return savedHistory;
  }

  const updatedItems = [...group.items];
  updatedItems.splice(itemIndex, 1);

  const updatedHistory = [...savedHistory];
  if (updatedItems.length > 0) {
    updatedHistory[groupItemIndex] = { ...group, items: updatedItems };
  } else {
    updatedHistory.splice(groupItemIndex, 1);
  }

  return updatedHistory;
};

export const initialState = {
  recentHistory: [],
  savedHistory: [],
  isRecentHistoryLoaded: false,
  isSavedHistoryLoaded: false,
  historyTypes: {},
  showSaveModal: false,
  itemToBeSaved: {},
  itemToBeSavedContext: '',
  saveModalTitle: '',
  saveModalNameInput: '',
  isInputTouched: false,
  isSaveInProgress: false,
  saveResult: {},
  error: {},
  itemTobeDeleted: {},
  showDeleteModal: false,
  isDeleteInProgress: false,
  itemIndex: 0,
  groupItemIndex: 0,
};

const handleOnSubmitComplete = (state, action) => {
  if (action.responseType !== 'success') {
    return { ...state, isSaveInProgress: false, error: { ...action.payload } };
  }

  if (action.isRename) {
    return {
      ...state,
      isSaveInProgress: false,
      saveResult: { ...action.payload },
      savedHistory: updateSavedHistoryOnRename(state),
    };
  }

  return { ...state, isSaveInProgress: false, saveResult: { ...action.payload } };
};

const handleOnDeleteComplete = (state, action) => {
  if (action.responseType === 'success') {
    return {
      ...state,
      isDeleteInProgress: false,
      savedHistory: updateSavedHistoryOnDelete(state),
    };
  }
  return { ...state, isDeleteInProgress: false };
};

// eslint-disable-next-line default-param-last
export default function historyReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVED_RECENT_HISTORY: {
      const { recentHistory, historyTypes } = action;
      AppStorage.instance.setToSessionStorage('HistoryTypes', historyTypes);
      return { ...state, recentHistory, historyTypes, isRecentHistoryLoaded: true };
    }
    case RECEIVED_SAVED_HISTORY: {
      const { savedHistory, historyTypes } = action;
      AppStorage.instance.setToSessionStorage('HistoryTypes', historyTypes);
      return { ...state, savedHistory, historyTypes, isSavedHistoryLoaded: true };
    }
    case HANDLE_VIEW_SAVE_MODAL: {
      const { show, historyItem, itemToBeSavedContext, title, itemIndex, groupItemIndex } = action;
      return {
        ...state,
        showSaveModal: show,
        itemToBeSaved: { ...historyItem },
        itemToBeSavedContext: show ? itemToBeSavedContext : '',
        saveModalTitle: show ? title : '',
        isInputTouched: !show ? false : state.isInputTouched,
        saveModalNameInput: show && title === 'Rename' ? historyItem?.searchName : '',
        error: !show ? {} : state.error,
        saveResult: !show ? {} : state.saveResult,
        itemIndex,
        groupItemIndex,
      };
    }
    case HANDLE_NAME_CHANGE: {
      return { ...state, saveModalNameInput: action.value, isInputTouched: true };
    }
    case ON_SUBMIT_SAVE: {
      return { ...state, isSaveInProgress: true };
    }
    case ON_SUBMIT_COMPLETE: {
      return handleOnSubmitComplete(state, action);
    }
    case HANDLE_VIEW_DELETE_MODAL: {
      return {
        ...state,
        itemTobeDeleted: action.historyItem,
        showDeleteModal: action.show,
        itemIndex: action.itemIndex,
        groupItemIndex: action.groupItemIndex,
      };
    }
    case ON_DELETE: {
      return { ...state, isDeleteInProgress: true };
    }
    case ON_DELETE_COMPLETE: {
      return handleOnDeleteComplete(state, action);
    }
    case ON_SAVE_UNLOAD: {
      return { ...state, isSavedHistoryLoaded: false };
    }
    default: {
      return state;
    }
  }
}
